<template>
  <div class="flex items-center justify-center">
    <div
      :style="{ width: `${size}px`, height: `${size}px` }"
      class="box-content rounded-full bg-primary p-3.5 text-text-primary"
    >
      <div class="spinner-box size-full">
        <div class="three-quarter-spinner size-full" />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
withDefaults(
  defineProps<{
    size?: string
  }>(),
  {
    size: '85'
  }
)
</script>

<style scoped>
.spinner-box {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: transparent;
}

.three-quarter-spinner {
  border: 3px solid #ff4342;
  border-top: 3px solid transparent;
  border-radius: 50%;
  animation: spin 0.5s linear 0s infinite;
}

@keyframes spin {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(359deg);
  }
}
</style>
